import templateUrl from './onboarding-application-detail-modal.html'

export const OnboardingApplicationDetailModalComponent = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    },
    controller: function OnboardingApplicationDetailModalController() {
        'ngInject'
        const $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.onboardingApplication = $ctrl.resolve.onboardingApplication;
        };

        $ctrl.onCancel = function () {
            $ctrl.dismiss({ $value: 'cancel' })
        };
    }
}

export const OnboardingApplicationDetailModal = {
    component: "apexOnboardingApplicationDetailModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
